import { Store } from 'redux';
import { externalStoreSetup } from '@everfi/reactifi';
import environment from '@/environment';
import reducers from '../reducers';

const store = (props: object, accessToken: string): Store => {
  return externalStoreSetup(reducers, props, environment.getAuthApp('HOMEROOM').url, 'api/v3', accessToken) as Store;
};

export default store;
